import { render, staticRenderFns } from "./closeIcon.vue?vue&type=template&id=741d2530&scoped=true&"
import script from "./closeIcon.vue?vue&type=script&lang=js&"
export * from "./closeIcon.vue?vue&type=script&lang=js&"
import style0 from "./closeIcon.vue?vue&type=style&index=0&id=741d2530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d2530",
  null
  
)

export default component.exports